module.exports = __webpack_public_path__ + "static/media/N4.1651c88f.png";